// HeaderBar.jsx
import React from 'react';
import add_contract_dialog from '../../assets/add_contract_dialog.svg';
import close_dialog from '../../assets/close_dialog.svg';

export default function HeaderBar({ onClose, editing = false }) {
  return (
    <div style={{ height: "30px", display: "flex", padding: "15px" }} id="draggable-dialog-title">
      <div style={{ display: "flex", gap: "10px" }}>
        <img
          src={add_contract_dialog}
          alt="add-contract-dialog"
          className="add-contract-dialog-icon"
          style={{ height: "20px", marginTop: "3px" }}
        />
        <span className="add-contract-dialog-title">
          {editing ? 'Edit expense' : ' Add a new expense'}
          </span>
      </div>
      <div style={{ flexGrow: 1, textAlign: 'right' }}>
        <img
          src={close_dialog}
          alt="close-dialog"
          className="close-dialog-icon-pop"
          onClick={onClose}
          style={{ marginTop: "5px", cursor: "pointer" }}
        />
      </div>
    </div>
  );
}
